import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-currencymaster',
  templateUrl: './currencymaster.component.html',
  styleUrls: ['./currencymaster.component.css']
})
export class CurrencymasterComponent extends BaseComponent implements OnInit {
  p = 1;
  ord = true;
  colname: "Name";
  text;
  today: number = Date.now();
  public currencyObj: any = [];
  constructor(
    private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService,
  ) {
    super();
  }

  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  ngOnInit() {
    this.getCurrenctData()
    this.CurrencyLogData()
  }
  CurrencyLogData() {
    let currencyLogs = {
      log_type:"Currency Master View" ,
      log_name:"Currency Master View" ,
      log_description:"Currency Master View" ,
      moduleid:1 ,
      moduleitemid:7,
      per_id:14
    }
    this.logs.addNewLogs(currencyLogs).subscribe(data => {


    }, error => {
     // console.log(error);
    });

}
  editCurrency(id) {
    this.router.navigate(['/corporate/addnewcurrency'], { queryParams: { currency_id: id } });
  }
  getCurrenctData() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getCurrency().subscribe(data => {
      self.currencyObj = data;
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  deleteCurrency(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delCurrency(obj).subscribe(data => {
            if (data.status) {
              this.getCurrenctData();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.currencyObj.find(element => {
      // console.log(element.get_master_company_type.company_type_id)
      if (element.get_master_currency.currency_id === id) {
        return true;
      }
    });
    obj = obj.get_master_currency;

    this.confirmationDialogService.confirm('PLEASE CONFIRM.', 'Are you sure you want to change the status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          obj.isactive = !obj.isactive;
          this.master.UpdateCurrency(obj).subscribe(data => {
            this.getCurrenctData()
            this.toastrService.success("Currency Master Status Changed Successfully");
            this.ngxSpinnerService.hide();
          });
        }
        // else {
        //   this.master.UpdateCurrency(obj).subscribe(data => {
        //     this.getCurrenctData()
        //     setTimeout(() => {
        //       this.toastrService.success("Status Changed Successfully");
        //     }, 1000)
        //   });
        // }
      }).catch(() => {
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }

  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length)
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      } else {
        event.target.src = '../../../assets/custom/images/broken.png';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }

  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }

  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-currency-import.csv`, 'addingCurrencyBulk')
      .then(data => {

        self.getCurrenctData();
      })
      .catch(err => {
        console.error(err);
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }

  exportFile() {
    let tablename = {
      "tableName": "master_currency_tbl"
    }
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }

}
